export default "__VITE_ASSET__d118ea89__"